import { api } from './api';

// Define a service using a base URL and expected endpoints
export const applicationApi = api.injectEndpoints({
  reducerPath: 'applicationApi',
  tagTypes: ['AppInfo', 'ConfFiles'],
  endpoints: (builder) => ({
    getConfiguration: builder.query({
      query: () => ({
        url: `/public/config/front.json`,
        method: 'GET'
      }),
      providesTags: ['ConfFiles']
    }),
    getApplicationInfo: builder.query({
      query: () => ({
        url: `/public/api/info`,
        method: 'GET'
      }),
      providesTags: ['AppInfo']
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetConfigurationQuery, useGetApplicationInfoQuery } = applicationApi;
